/* eslint-disable max-len */
import { ReactNode } from 'react'

import Icon from 'lib/components/Icon/Icon'

import { useGetFacilityApi } from '@/api/useGetFacilityApi'
import { AddressInputAddress, RecognizedPlace } from './AddressInput'

interface Props {
  address?: AddressInputAddress
  brandLabel?: string
  recognizedPlace?: RecognizedPlace
}

const RecognizedPlaceCard = ({
  address,
  brandLabel,
  recognizedPlace,
}: Props): ReactNode => {
  const { data } = useGetFacilityApi(recognizedPlace?.id)

  if (!address) return null

  return (
    <>
      <div className="mt-6 w-full max-w-4xl rounded-2xl bg-white p-6">
        <div className="flex flex-col items-center gap-2 text-center">
          {data?.partner && (
            <div className="flex items-center gap-1.5 rounded bg-theme-secondary px-2.5 py-1 text-xs font-medium text-white">
              {recognizedPlace?.icon && (
                <Icon
                  icon={recognizedPlace.icon}
                  className={recognizedPlace.iconClassName}
                />
              )}
              {brandLabel && <span>{brandLabel} Partner</span>}
            </div>
          )}

          <h2 className="text-xl font-bold text-black">
            {address.company_name}
          </h2>
        </div>

        <p className="mt-2 text-center text-base text-gray-800">
          {address.formatted_address}
        </p>
      </div>
    </>
  )
}

export default RecognizedPlaceCard
